import {Component, Input} from '@angular/core';
import {Clause} from '../../../../models/product.model';

@Component({
    selector: 'app-clauses-output',
    templateUrl: './clauses-output.component.html'
})
export class ClausesOutputComponent {
    @Input() clauses: Clause[];
    @Input() yesLabel = 'LABELS.AGREE';
    @Input() noLabel = 'LABELS.REFUSED';
    @Input() owuNumber: string;

    getClauseDescription(clause: Clause) {
        if (clause?.item){
            return clause?.item?.description
                ? clause?.item?.description?.split('%s').join(this.owuNumber)
                : '';
        } else {
            return clause?.description
                ? clause?.description?.split('%s').join(this.owuNumber)
                : '';
        }
    }
}
